import { BaseApiService } from './BaseApiService';
import { sharedTokenRefresh } from './tokenRefresh';
import { debugError } from '../utils/debug';

/**
 * Service for feature flag API operations
 */
export class FeatureFlagApiService extends BaseApiService {
    constructor() {
        super(sharedTokenRefresh);
    }

    /**
     * Get all feature flags for the current environment
     * @returns Promise containing dictionary of feature flag names to enabled status
     */
    async getFeatureFlags(): Promise<Record<string, boolean>> {
        try {
            const response = await this.postJson('/v1/feature-flags/get', {});
            const result = await this.handleResponse<Record<string, boolean>>(response);
            return result;
        } catch (error) {
            debugError('Error getting feature flags:', error);
            throw error;
        }
    }

    /**
     * Check if a specific feature flag is enabled
     * @param flagName - Name of the feature flag to check
     * @returns Promise containing enabled status
     */
    async getFeatureFlag(flagName: string): Promise<{ flagName: string; enabled: boolean }> {
        try {
            const response = await this.postJson('/v1/feature-flags/get-flag', { flagName });
            const result = await this.handleResponse<{ flagName: string; enabled: boolean }>(response);
            return result;
        } catch (error) {
            debugError('Error getting feature flag:', error);
            throw error;
        }
    }
}

export const featureFlagApiService = new FeatureFlagApiService();
